import axios from 'axios'
const AGE_OFFSET = 30000
const DIMENSION_LABELS = {
  x               : 'width',
  y               : 'height',
  z               : 'length',
  delimiterShort  : 'mm',
  delimiterLong   : 'millimetres',
}

export const state = {
  siteData: null,
  lastRequestTime: 0,
}
export const getters = {
  getSiteData: (state)  => {
    if (state.siteData) {
      return state.siteData
    }
    return null;
  },
  getSiteDataAge: (state)  => {
    if (state.lastRequestTime) {
      return state.lastRequestTime
    }
    return 0;
  },
}

export const mutations = {
  SET_SITE_DATA(state, siteData) {
    state.siteData = siteData
    state.lastRequestTime = Date.now()
  },
}

export const actions = {
  resolveSiteData({ commit, getters }, forced = false) {
    if (forced || ((getters.getSiteDataAge + AGE_OFFSET) < Date.now())){
      axios.get(`/site-data`).then(({ data }) => {
        commit('SET_SITE_DATA', { ...data, dimensionLabels: { ...DIMENSION_LABELS }})
      })
    }
    return getters.getSiteData
  },
}
